var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1999 11.4V10.2M11.9999 11.4V9M16.7999 11.4V6.6M9.5999 16.2L7.7999 21M16.5935 20.9333L14.4722 16.2664M4.7999 16.2C3.47442 16.2 2.3999 15.1255 2.3999 13.8V5.4C2.3999 4.07452 3.47442 3 4.7999 3H19.1999C20.5254 3 21.5999 4.07452 21.5999 5.4V13.8C21.5999 15.1255 20.5254 16.2 19.1999 16.2H4.7999Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.de3d31529b3e82b4310fef17e7dfa9f7.svg";
export { ForwardRef as ReactComponent };